module.exports = __webpack_public_path__ + "static/img/pcc_logo.c197b15b.png";